import React, { useState, useEffect } from 'react'
import { useSearchParams} from "react-router-dom";

import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Typography, Button } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import DeleteNotification from '../../core/components/DeleteNotification';
import {CoreContext} from "../../core/context/CoreContext";
import PageWaiting from '../../core/components/PageWaiting';
import {isMobile} from 'react-device-detect';

import {getListAPI, deleteAPI} from './ProductrawAPI';
import {getColumns} from './ProductrawStruct';
import ListCardView from '../../core/components/card/ListCardView';
import ListTableView from '../../core/components/card/ListTableView';

import {getProductrawView} from './ProductrawView';
import CardListLayout from '../../core/components/card/layout/CardListLayout';
import { useSelector, useDispatch } from 'react-redux';
import {setViewParams} from '../../store/slice/ChoiceSelectionSlice';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';

import {setFilter} from '../../store/slice/ConfSlice';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import MyPageContainer from '../../core/template/MyPageContainer';
import { deleteProductrawObj  ,setSelectedProductrawId,setSelectedActionId , setShowEditForProductraw} from 'store/slice/PharmaSlice';

import ProductrawListTable from './components/ProductrawListTable';
import { useNavigate } from "react-router-dom";
import { setClickedBo,setActionClicked } from 'store/slice/BreadCrumSlice';

import { transformDateValue } from 'core/js/FormUtils';
import RawDemandMgmt from 'components/rawdemand/components/RawDemandMgmt';

export default function ProductrawListImpl( {tableList, cardList, setShowEdit, setProductrawId}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setNotification, setShowLoading, showloading, lastURL } = React.useContext(CoreContext);
  const columns = getColumns(editCallBack, initDeleteCallBack);
  const [view, setView] = useState(1);
  const { showfilter } = useSelector((state) => state.confslice);
  

  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const {selectedId, productrawObj} = useSelector((state)=>state.pharmaslice.productrawDashboard);
  const { productrawList } = useSelector((state) => state.pharmaslice.productrawDashboard);
  

  useEffect(() => {
    console.log("productrawList=>"+productrawList.length)
  }, [productrawList, productrawObj])
  
  function initDeleteCallBack(id){
    dispatch(setSelectedProductrawId(id));
    setShowDeleteAlert(true);
  }
  function deleteCallBack(obj){
    dispatch(deleteProductrawObj(obj.id));
    setNotification('Record deleted successfully !!!')
  }
  function deleteRecord(){
    deleteAPI(selectedId,deleteCallBack);
    setShowDeleteAlert(false);
  }

  function editCallBack(id){
    dispatch(setSelectedProductrawId(id));
    dispatch(setShowEditForProductraw(true));
  }
  
  const createProductraw=()=>{
    dispatch(setSelectedProductrawId(-1));
    dispatch(setShowEditForProductraw(true));
  }



const getDataWithDateTransformation = (data) =>{
    let newData = {
      ...data,
      'expand':false,

    }
    return newData;
  }
  const productrawTransformation = (tableList) =>{
    let newDataList=[]
    tableList.map((data)=>{ 
      newDataList.push(getDataWithDateTransformation(data));
     })
    return newDataList;
  }

  const payload = {
    productrawList:productrawList,
    cardList:getProductrawView(tableList),
        actionList: [
          {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
          {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
          
        ],
        dialogueActionList: [
          
        ],
    tableView:{
      tableList:productrawTransformation(tableList),
      productrawList:productrawList,
      actionList:[
        {title:'Edit', callBackMethod:editCallBack, icon:<EditIcon/>, status:'NA'},
        {title:'Delete', callBackMethod:initDeleteCallBack, icon:<DeleteIcon/>, status:'NA'},
        
      ]
    }
  }
  
  const getPayload = ()=>{
    return payload;
  }

  useEffect(()=>{
    if (document.body.offsetWidth<500)  setView(0);
    dispatch(setViewParams({
      colsCount:{xs:12, sm:4, md:4, lg:4},
      modal:{
            
      }
      }))
  },[])

  return (
   <>
   {showloading?<PageWaiting/>:
      <Grid container direction="column" padding={2}>
              <Grid item>
                  <Grid container direction="row" justifyContent={'space-between'} alignContent={'center'}>
                      <Grid item>
                        <Typography variant='h4'>Raw Material of Product List</Typography>
                      </Grid>
                      <Grid item>
                        <Grid container justifyContent={'flex-end'} spacing={1}>
                        {showfilter?
                            <Grid item>
                              <Tooltip title="Hide filter" sx={{cursor: "pointer"}}>
                                <FilterAltOffIcon onClick={()=>{dispatch(setFilter(false))}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Show filter" sx={{cursor: "pointer"}}>
                                <FilterAltIcon onClick={()=>{dispatch(setFilter(true))}}/>
                              </Tooltip>
                            </Grid>
                            }
                            {view===1?
                            <Grid item>
                              <Tooltip title="Grid View" sx={{cursor: "pointer"}}>
                                <ViewWeekIcon onClick={()=>{setView(0)}}/>
                              </Tooltip>
                            </Grid>
                            :
                            <Grid item>
                              <Tooltip title="Table View" sx={{cursor: "pointer"}}>
                                <CalendarViewMonthIcon onClick={()=>{setView(1)}}/>
                              </Tooltip>
                            </Grid>
                            }
                            <Grid item>
                              <Tooltip title="Add Productraw" sx={{cursor: "pointer"}}>
                                <AddIcon onClick={()=>{createProductraw()}}/>
                              </Tooltip>
                            </Grid>
                          </Grid>
                      </Grid>
                      
                  </Grid>
              </Grid>
              <Grid item>
                  { view===0? 
                      <CardListLayout payload={getPayload()}/>
                    :
                    <>
                    <MyPageContainer  containedComponent = {
                      < ProductrawListTable 
                        payload={getPayload().tableView}
                        />
                    }/>
                   <RawDemandMgmt/>
                    </>
                  }
              </Grid>     
      </Grid>
   }
    { showDeleteAlert?<DeleteNotification 
            id={selectedId}
            width="50%"
            setShowDeleteAlert={setShowDeleteAlert}
            deleteRecord = {deleteRecord}/>: ''
    }

    
    </>
);


}